import React from 'react';
import DatePicker from "react-multi-date-picker"
import { Button, Grid, TextField, MenuItem, Select } from '@mui/material';
import "react-multi-date-picker/styles/colors/green.css"
import DatePanel from "react-multi-date-picker/plugins/date_panel"
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import { useSelector } from 'react-redux'
import moment from 'moment';
import useSubmitLock from '../../../../../hooks/useSubmitLock';

const { REACT_APP_API_URL } = process.env;


export default function AltaEnfermedadGyLicencia140(props) {
  const { lote } = props
  const { periodo } = props
  const { idempleado } = props
  const { notificacion } = props
  const { idconcepto } = props
  const { obtenerdatolote } = props
  const { datotodoempleado } = props
  const { submitting, runWithSubmitLock } = useSubmitLock()

  const [datearray, setDatearray] = React.useState();
  const [dates, setDates] = React.useState();
  const [ramoseguro, SetRamoseguro] = React.useState('');
  const [controlincapacidad, SetControlIncapacidad] = React.useState('');
  const [folioseguro, setFolioseguro] = React.useState('');
  const [descripcion, setDescripcion] = React.useState('')
  const [diasautorizados, setDiasaut] = React.useState(1)

  const fecha = periodo.fechafin
  const fechainicial = new Date(fecha);
  fechainicial.setDate(fechainicial.getDate() + 1)

  var fechafinal = moment(fechainicial).format('YYYY-MM-DD');


  const arrayramoseguro = useSelector(store => store.menus.ramoseguro)
  const arraycontrolincapacidad = useSelector(store => store.menus.controlincapacidad)


  const weekDays = ["Dom", "Lun", "Mar", "Mier", "Jue", "Vier", "Sab"]
  const months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]



  const Addaltafestivo = (e) => {
    e.preventDefault()
    runWithSubmitLock(async () => {
    const token = sessionStorage.getItem('%t')
    const resul = {
      variant: 'warning',
      msg: 'Debe seleccionar por lo menos una fecha'
    }
   
  
    if (datearray === '' || idempleado === '') {
      notificacion(resul)
    } else {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${token}`);
      myHeaders.append("Content-Type", "application/json");


      var raw = JSON.stringify({
        "idlote": lote,
        "idperiodo": periodo.idperiodo,
        "idempleado": idempleado,
        "codigoempleado": datotodoempleado.codigoempleado,
        "nombrelargo": datotodoempleado.nombrelargo,
        "idtipoincidencia": `${idconcepto}`,
        "fechaInicioIncapacidad": datearray,
        "fechaFinPeriodo": fechafinal,
        "diasAutorizados": diasautorizados,
        "folio": folioseguro,
        "descripcion": descripcion,
        "ramoSeguro": ramoseguro,
        "controlIncapacidad": controlincapacidad,
      });

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };

      try {
        const response = await fetch(`${REACT_APP_API_URL}/pdim/incidencia`, requestOptions)
        const resultado = await response.json();



        return (notificacion(resultado), obtenerdatolote(lote), setDatearray(''), setDates({}), setDescripcion(''), setFolioseguro(''), SetControlIncapacidad(''), SetRamoseguro(''))
      } catch (error) {
        console.log('Algo salio mal', error);
      }
    }
    })
  }

  const handchange = (date) => {
    setDates(date);
    const fechastring = date.toString();
    setDatearray(fechastring);
  };



  const min = 1;
  const max = 90;
  return (
    <div  >
      <br /> <br />
      <form onSubmit={Addaltafestivo}>
        <Grid container spacing={3}>
          <Grid item>
            <DatePicker
              weekDays={weekDays}
              months={months}
              arrow={false}
              mainPosition="top"
              fixMainPosition={true}
              calendarPosition={`top-center`}
              style={{
                backgroundColor: "aliceblue",
                height: "45px",
                borderRadius: "3px",
                fontSize: "16px",
                padding: "3px 10px"
              }}
              disableYearPicker
              className="green"
              value={dates}
              onChange={handchange}
              format="YYYY-MM-DD"
              sort
              plugins={[
                <DatePanel />
              ]}
            />
            <FormHelperText id="outlined-weight-helper-text">Fecha de inicio*</FormHelperText>
          </Grid>
          <Grid item>
            <FormControl fullWidth sx={{ m: 1 }}>
              <TextField
                fullWidth
                value={diasautorizados}
                inputProps={{ min, max }}
                onChange={(e) => {
                  var value = parseInt(e.target.value, 10);
                  if (value > max) value = max;
                  if (value < min) value = min;
                  setDiasaut(value);
                }}
                placeholder="0"
                variant="standard"
                type='number'
                size="small"
              />
              <FormHelperText id="outlined-weight-helper-text">Días autorizados*</FormHelperText>
            </FormControl>
          </Grid>
        </Grid>

        <Grid container spacing={3}>
          <Grid item >
            <FormControl fullWidth sx={{ m: 1 }}>
              <TextField
                required
                placeholder="VP911361"
                inputProps={{ maxLength: 8 }}
                defaultValue={folioseguro}
                onChange={e => setFolioseguro(e.target.value)}
                variant="standard"
                type='text'
                size="small"
              />
              <FormHelperText id="outlined-weight-helper-text">Folio de seguro*</FormHelperText>
            </FormControl>
          </Grid>

          <Grid item >
            <FormControl variant="standard" sx={{ m: 1, }} fullWidth>
              <Select
                labelId="demo-simple-select-standard-label"
                required
                id="demo-simple-select-standard"
                value={ramoseguro}
                onChange={e => SetRamoseguro(e.target.value)}
                label="Ramo seguro"
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {
                  arrayramoseguro.map((row, index) =>
                    <MenuItem key={index} value={row.FieldValue}>{row.UserValue}</MenuItem>
                  )
                }
              </Select>
              <FormHelperText id="outlined-weight-helper-text">Ramo seguro*</FormHelperText>
            </FormControl>

          </Grid>

          <Grid item >
            <FormControl variant="standard" fullWidth sx={{ m: 1 }}>
              <Select
                required
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={controlincapacidad}
                onChange={e => SetControlIncapacidad(e.target.value)}
                label="Ramo seguro"
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {arraycontrolincapacidad.map((row, Index) =>
                  <MenuItem key={Index} value={row.FieldValue}>{row.UserValue}</MenuItem>
                )}

              </Select>
              <FormHelperText id="outlined-weight-helper-text">Control incapacidad*</FormHelperText>
            </FormControl>
          </Grid>

        </Grid>

        <Grid container spacing={2}>


        </Grid>
        <FormControl fullWidth sx={{ m: 1 }}>
          <TextField
            multiline
            fullWidth
            placeholder="Descripción"
            defaultValue={descripcion}
            onChange={e => setDescripcion(e.target.value)}
            variant='filled'
            type='text'
            size="small"
          />
          <FormHelperText id="outlined-weight-helper-text">Descripcion:</FormHelperText>
        </FormControl>


        <br />
        <Button type='submit' color="primary" variant='contained' disabled={submitting}>Agregar
        </Button>
      </form>
    </div>
  );
}
